import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "history-of-changes-list" }
const _hoisted_2 = { class: "history-of-changes-list__content-list" }
const _hoisted_3 = {
  key: 0,
  class: "history-of-changes-list__content-loading-spinner"
}

import HistoryOfChangesItem from './HistoryOfChangesItem.vue';

import { TirPmSpinner } from 'tir-pm-spinner';
import { onBeforeMount, onMounted, PropType, ref } from 'vue';
import { AdapterService } from './adapter';
import { TaskHistoryModel } from './models';
import { TirPmScrollbar } from 'tir-pm-scrollbar';

/**Параметры компонента */

export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryOfChangesList',
  props: {
  /** Id задачи */
  taskId: { type: Number as PropType<number>, default: null },
},
  setup(__props) {

const props = __props;



const pageRequest = ref({
  Skip: 0,
  Take: 15,
});

/**Кол-во записей */
let countHistory: number | undefined;

/**
 *  Проверить проскроллен ли элемент до конца
 * @param element Элемент
 * @returns
 */

const checkScrolledToBottom = (element: HTMLElement): boolean =>
  element.scrollTop + element.clientHeight >= element.scrollHeight;

/**При скролле */
const onScoll = (event: any) => {
  const target = event.target as HTMLElement | undefined;
  if (
    !target ||
    !checkScrolledToBottom(target) ||
    isLoadingMore.value ||
    pageRequest.value.Skip >= countHistory
  )
    return;

  getTaskHistory();
};

const adapter = new AdapterService();

const dataOfHistory = ref<Array<TaskHistoryModel>>([]);
const isLoadingMain = ref(false);
const isLoadingMore = ref(false);

/**Запрос за компонентом */
const getTaskHistory = async () => {
  isLoadingMain.value = true;
  if (props.taskId) {
    const resp = await adapter.getTaskHistory(props.taskId, pageRequest.value);
    isLoadingMain.value = false;
    if (!resp.IsSuccess) return;

    dataOfHistory.value.push(...resp.Value.Items);
    pageRequest.value.Skip += resp.Value.Page.Size;
    countHistory = resp.Value.Page.Count;
  }
};

onMounted(() => {
  // adapter.subscribeGetTaskHistory();
});

onBeforeMount(async () => {
  await getTaskHistory();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmScrollbar), {
      class: "history-of-changes-list__scroller",
      showOnHover: "",
      onOnScroll: onScoll
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (!dataOfHistory.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(TirPmSpinner))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataOfHistory.value, (itemHistory) => {
            return (_openBlock(), _createBlock(HistoryOfChangesItem, {
              historyItemData: itemHistory,
              key: itemHistory.Id
            }, null, 8, ["historyItemData"]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})